import { useState } from 'react';
import { useAudit } from '../api/queries.js';
import { Badge, Card, Loading, Mono, Page, Problem, Table } from '../components/ui.jsx';
import { formatDateTime, formatNumber } from '../utils/format.js';

/**
 * The audit trail is not a table someone has to remember to write to: it is the event log itself.
 * Nothing can happen in Broker without appearing here, with who did it and in which position of
 * the log — and nothing here can ever be edited or removed.
 */
export function Audit() {
  const [includeTraffic, setIncludeTraffic] = useState(false);
  const audit = useAudit(includeTraffic);

  if (audit.isLoading) return <Loading what="il registro" />;
  if (audit.error) return <Problem error={audit.error} />;

  return (
    <Page
      eyebrow="SISTEMA"
      title="Audit"
      description="Il registro dei fatti, in sola aggiunta. È la fonte da cui ogni vista di Broker è ricostruita."
      actions={
        <label className="checkbox">
          <input type="checkbox" checked={includeTraffic} onChange={(event) => setIncludeTraffic(event.target.checked)} />
          Includi il traffico dei messaggi
        </label>
      }
    >
      <Card title={`${formatNumber(audit.data!.total)} fatti`} hint="I più recenti per primi">
        <Table
          head={
            <tr>
              <th>#</th>
              <th>Quando</th>
              <th>Fatto</th>
              <th>Oggetto</th>
              <th>Autore</th>
              <th>Dettaglio</th>
            </tr>
          }
          empty="Il registro è vuoto."
        >
          {audit.data!.events.map((entry) => (
            <tr key={entry.sequence}>
              <td className="mono muted">{entry.sequence}</td>
              <td className="muted small">{formatDateTime(entry.occurredAt)}</td>
              <td>
                <Badge tone="info">{entry.type}</Badge>
              </td>
              <td>
                <span className="muted small">{entry.streamKind}</span> <Mono value={entry.streamId} /> <span className="muted small">v{entry.version}</span>
              </td>
              <td>
                {entry.actor.label ?? entry.actor.id}
                <br />
                <span className="muted small">{entry.actor.kind}</span>
              </td>
              <td>
                <details>
                  <summary className="muted small">Vedi</summary>
                  <pre className="payload">{JSON.stringify(entry.body, null, 2)}</pre>
                </details>
              </td>
            </tr>
          ))}
        </Table>
      </Card>
    </Page>
  );
}
